import { render, staticRenderFns } from "./CreateCSPO.vue?vue&type=template&id=39fa21d3&scoped=true&"
import script from "./CreateCSPO.vue?vue&type=script&lang=js&"
export * from "./CreateCSPO.vue?vue&type=script&lang=js&"
import style0 from "./CreateCSPO.vue?vue&type=style&index=0&id=39fa21d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fa21d3",
  null
  
)

export default component.exports